import { SideNav } from "components";
import { Icons, LargeButton, MainBody, PageTitle, Ptag } from "components/core";
import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import useFetchWellness from "./useFetchWellness";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { BenefitDetailBlockWrapper } from "./styles";
import routes from "components/routes";

export const DetailBlock = ({ title, children }) => {
  return (
    <section>
      <Ptag fontSize="14px">{title}</Ptag>
      <Ptag fontSize="16px" fontWeight="700" marginTop="6px">
        {children}
      </Ptag>
    </section>
  );
};
export const DetailBlockMain = ({ title, children }) => {
  return (
    <section
      style={{
        marginTop: "26px",
      }}
    >
      <Ptag fontSize="14px">{title}</Ptag>
      <section style={{ marginTop: "6px" }}>{children}</section>
    </section>
  );
};

function BenefitSummary() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSelectionID = location.state?.benefitId;
  const { getLocalBenefits, getSelectedWellness, getPlanBenefitData } =
    useFetchWellness();

  const selectedBenefitsDetails = useMemo(() => {
    const localBenefits = getLocalBenefits();
    const localSelectedBenefits = getSelectedWellness();
    const benefits = localBenefits.filter((ben) =>
      localSelectedBenefits.includes(ben?.id)
    );
    return benefits;
  }, []);

  const navigateToProducts = () => {
    navigate(`/${routes.UNIVERSAL_PLAN_SETUP}`, {
      state: {
        wellness: true,
      },
    });
  };

  const [expanded, setExpanded] = useState(
    pathSelectionID || selectedBenefitsDetails[0].id
  );
  const [selectedBenefitDetail, setSelectedBenefitDetail] = useState();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const isOldFlow = useMemo(() => {
    if (location?.pathname.includes("v1")) {
      return false;
    }
    return true;
  }, [location]);

  useEffect(() => {
    (async function () {
      const index = selectedBenefitsDetails.findIndex(
        (ben) => ben.id === expanded
      );
      const data = await getPlanBenefitData(selectedBenefitsDetails[index].id);
      setSelectedBenefitDetail(data);
    })();
  }, [expanded]);

  console.log({ selectedBenefitDetail, expanded });

  return (
    <>
      {isOldFlow && <SideNav></SideNav>}
      {isOldFlow ? (
        <MainBody>
          <PageTitle title="Wellness" />
          <div style={{ maxWidth: "932px" }}>
          {selectedBenefitDetail?.length === 1 && (
            <>
              {selectedBenefitsDetails.map((benefit) => (
                <Accordion
                  expanded={expanded === benefit.id}
                  onChange={handleChange(benefit.id)}
                  sx={{
                    boxShadow: "none",
                    border: "1px solid #F7ECFF",
                    marginBottom: "1rem",
                    borderRadius: "8px",
                    overflow: "hidden",
                  
                  }}
                >
                  <AccordionSummary
                    sx={{
                      background:
                        expanded === benefit.id ? "#221B3C" : "white",
                    }}
                    expandIcon={<Icons icon="chevron_down" fill={expanded === benefit.id ? "#ffffff" : "#231A3D"} />}
                  >
                    <div
                      style={{
                        margin: "1rem 2rem",
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Ptag
                        fontWeight="600"
                        fontSize="16px"
                        color={expanded === benefit.id ? "white" : "#231A3D"}
                      >
                        {benefit?.display_name}
                      </Ptag>
                    </div>
                  </AccordionSummary>
                    <AccordionDetails
               
                    sx={{
                      background: "white",
                      padding: "32px",
                    }}
                  >
                    <BenefitDetailBlockWrapper>
                      {selectedBenefitDetail?.[0]?.entity_id && (
                        <DetailBlock title="Entity ID">
                          {selectedBenefitDetail[0].entity_id}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.vendor_name && (
                        <DetailBlock title="Vendor">
                          {selectedBenefitDetail[0].vendor_name}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.dependents_covered && (
                        <DetailBlock title="Dependents Covered ">
                          {selectedBenefitDetail[0].dependents_covered.join(
                            ", "
                          )}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.redeem_option_data && (
                        <DetailBlock title="Coupon">
                          {selectedBenefitDetail[0].redeem_option_data}
                        </DetailBlock>
                      )}
                    </BenefitDetailBlockWrapper>
                     
                    {selectedBenefitDetail?.[0]?.benefit_heading && (
                   
                      <DetailBlockMain title="Benefit Heading">
                        <Ptag color="#4A4A4A" fontSize="16px">
                          {selectedBenefitDetail?.[0]?.benefit_heading}
                        </Ptag>
                      </DetailBlockMain>
                    )}
                    {selectedBenefitDetail?.[0]?.benefit_description && (
                      <DetailBlockMain title="Benefit Description">
                        <Ptag color="#4A4A4A" fontSize="16px">
                          {selectedBenefitDetail?.[0]?.benefit_description}
                        </Ptag>
                      </DetailBlockMain>
                    )}
                    {selectedBenefitDetail?.[0]?.benefit_details?.filter(det => det && det.trim() !== "").length > 0 && (
                      <DetailBlockMain title="Benefit Details">
                        <ul
                          style={{
                            listStylePosition: "inside",
                          }}
                        >
                          {selectedBenefitDetail?.[0]?.benefit_details.filter(det => det && det.trim() !== "").map(
                            (det) => (
                              <li
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "Inter",
                                  color: "#4a4a4a",
                                  fontWeight: "500",
                                }}
                              >
                                {det}
                              </li>
                            )
                          )}
                        </ul>
                      </DetailBlockMain>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}
          {selectedBenefitDetail?.length > 1 && (
            <>
              {selectedBenefitsDetails.map((benefit) => (
                <Accordion
                  expanded={expanded === benefit.id}
                  onChange={handleChange(benefit.id)}
                  sx={{
                    boxShadow: "none",
                    border: "1px solid #F7ECFF",
                    marginBottom: "1rem",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      background:
                        expanded === benefit.id ? "#221B3C" : "transparent",
                    }}
                    expandIcon={<Icons icon="chevron_down" fill={expanded === benefit.id ? "#ffffff" : "#231A3D"} />}
                  >
                    <div
                      style={{
                        margin: "1rem 2rem",
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Ptag
                        fontWeight="600"
                        fontSize="14px"
                        color={expanded === benefit.id ? "white" : "#231A3D"}
                      >
                        {benefit?.display_name}
                      </Ptag>
                    </div>
                  </AccordionSummary>
                  
                  <AccordionDetails
                    sx={{
                      background: "white",
                      padding: "32px",
                    }}
                  >
                    {selectedBenefitDetail?.map((benefit_detail, idx) => (
                      <Accordion
                        defaultExpanded={idx === 0}
                        sx={{
                          boxShadow: "none",
                          border: "1px solid #F7ECFF",
                          marginBottom: "1rem",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <AccordionSummary
                          sx={{
                            background: "#FDEFCC",
                          }}
                          expandIcon={
                            <Icons icon="chevron_down" fill="#ffffff" />
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                            }}
                          >
                            <Ptag
                              fontWeight="600"
                              fontSize="14px"
                              color="#231A3D"
                            >
                              Grade {idx + 1} ({benefit_detail?.grade_code})
                            </Ptag>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            background: "white",
                            padding: "32px",
                          }}
                        >
                          <BenefitDetailBlockWrapper>
                            {benefit_detail?.entity_id && (
                              <DetailBlock title="Entity ID">
                                {benefit_detail.entity_id}
                              </DetailBlock>
                            )}
                            {benefit_detail?.dependents_covered && (
                              <DetailBlock title="Dependents Covered">
                                {benefit_detail.dependents_covered.join(", ")}
                              </DetailBlock>
                            )}
                            {benefit_detail?.redeem_option_data && (
                              <DetailBlock title="Coupon">
                                {benefit_detail.redeem_option_data}
                              </DetailBlock>
                            )}
                          </BenefitDetailBlockWrapper>
                          {benefit_detail?.benefit_heading && (
                            <DetailBlockMain title="Benefit Heading">
                              <Ptag color="#4A4A4A" fontSize="16px">
                                {benefit_detail?.benefit_heading}
                              </Ptag>
                            </DetailBlockMain>
                          )}
                          {benefit_detail?.benefit_description && (
                            <DetailBlockMain title="Benefit Description">
                              <Ptag color="#4A4A4A" fontSize="16px">
                                {benefit_detail?.benefit_description}
                              </Ptag>
                            </DetailBlockMain>
                          )}
                          {benefit_detail?.benefit_details?.filter(det => det && det.trim() !== "").length > 0 && (
                            <DetailBlockMain title="Benefit Details">
                              <ul
                                style={{
                                  listStylePosition: "inside",
                                }}
                              >
                                {benefit_detail?.benefit_details.filter(det => det && det.trim() !== "").map((det) => (
                                  <li
                                    key={det}
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Inter",
                                      color: "#4a4a4a",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {det}
                                  </li>
                                ))}
                              </ul>
                            </DetailBlockMain>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}
          <LargeButton
            label="Submit"
            style={{
              marginTop: "32px",
            }}
            onClick={navigateToProducts}
          />
          </div>
        </MainBody>
      ) : (
        <div style={{ maxWidth: "932px" }}>
          {selectedBenefitDetail?.length === 1 && (
            <>
              {selectedBenefitsDetails.map((benefit) => (
                <Accordion
                  expanded={expanded === benefit.id}
                  onChange={handleChange(benefit.id)}
                  sx={{
                    boxShadow: "none",
                    border: "1px solid #F7ECFF",
                    marginBottom: "1rem",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      background:
                        expanded === benefit.id ? "#221B3C" : "transparent",
                    }}
                    expandIcon={<Icons icon="chevron_down" fill={expanded === benefit.id ? "#ffffff" : "#231A3D"} />}
                  >
                    <div
                      style={{
                        margin: "1rem 2rem",
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Ptag
                        fontWeight="600"
                        fontSize="14px"
                        color={expanded === benefit.id ? "white" : "#231A3D"}
                      >
                        {benefit?.display_name}
                      </Ptag>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      background: "white",
                      padding: "32px",
                    }}
                  >
                    <BenefitDetailBlockWrapper>
                      {selectedBenefitDetail?.[0]?.entity_id && (
                        <DetailBlock title="Entity ID">
                          {selectedBenefitDetail[0].entity_id}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.vendor_name && (
                        <DetailBlock title="Vendor">
                          {selectedBenefitDetail[0].vendor_name}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.dependents_covered && (
                        <DetailBlock title="Dependents Covered">
                          {selectedBenefitDetail[0].dependents_covered.join(
                            ", "
                          )}
                        </DetailBlock>
                      )}
                      {selectedBenefitDetail?.[0]?.redeem_option_data && (
                        <DetailBlock title="Coupon">
                          {selectedBenefitDetail[0].redeem_option_data}
                        </DetailBlock>
                      )}
                    </BenefitDetailBlockWrapper>
                    {selectedBenefitDetail?.[0]?.benefit_heading && (
                      <DetailBlockMain title="Benefit Heading">
                        <Ptag color="#4A4A4A" fontSize="16px">
                          {selectedBenefitDetail?.[0]?.benefit_heading}
                        </Ptag>
                      </DetailBlockMain>
                    )}
                    {selectedBenefitDetail?.[0]?.benefit_description && (
                      <DetailBlockMain title="Benefit Description">
                        <Ptag color="#4A4A4A" fontSize="16px">
                          {selectedBenefitDetail?.[0]?.benefit_description}
                        </Ptag>
                      </DetailBlockMain>
                    )}
                    {selectedBenefitDetail?.[0]?.benefit_details?.filter(det => det && det.trim() !== "").length > 0 && (
                      <DetailBlockMain title="Benefit Details">
                        <ul
                          style={{
                            listStylePosition: "inside",
                          }}
                        >
                          {selectedBenefitDetail?.[0]?.benefit_details.filter(det => det && det.trim() !== "").map(
                            (det) => (
                              <li
                                style={{
                                  fontSize: "16px",
                                  fontFamily: "Inter",
                                  color: "#4a4a4a",
                                  fontWeight: "500",
                                }}
                              >
                                {det}
                              </li>
                            )
                          )}
                        </ul>
                      </DetailBlockMain>
                    )}
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}
          {selectedBenefitDetail?.length > 1 && (
            <>
              {selectedBenefitsDetails.map((benefit) => (
                <Accordion
                  expanded={expanded === benefit.id}
                  onChange={handleChange(benefit.id)}
                  sx={{
                    boxShadow: "none",
                    border: "1px solid #F7ECFF",
                    marginBottom: "1rem",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <AccordionSummary
                    sx={{
                      background:
                        expanded === benefit.id ? "#221B3C" : "transparent",
                    }}
                    expandIcon={<Icons icon="chevron_down" fill={expanded === benefit.id ? "#ffffff" : "#231A3D"} />}
                  >
                    <div
                      style={{
                        margin: "1rem 2rem",
                        display: "flex",
                        alignItems: "flex-end",
                      }}
                    >
                      <Ptag
                        fontWeight="600"
                        fontSize="14px"
                        color={expanded === benefit.id ? "white" : "#231A3D"}
                      >
                        {benefit?.display_name}
                      </Ptag>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      background: "white",
                      padding: "32px",
                    }}
                  >
                    {selectedBenefitDetail?.map((benefit_detail, idx) => (
                      <Accordion
                        defaultExpanded={idx === 0}
                        sx={{
                          boxShadow: "none",
                          border: "1px solid #F7ECFF",
                          marginBottom: "1rem",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                      >
                        <AccordionSummary
                          sx={{
                            background: "#FDEFCC",
                          }}
                          expandIcon={
                            <Icons icon="chevron_down" fill="#ffffff" />
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-end",
                            }}
                          >
                            <Ptag
                              fontWeight="600"
                              fontSize="14px"
                              color="#231A3D"
                            >
                              Grade {idx + 1} ({benefit_detail?.grade_code})
                            </Ptag>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails
                          sx={{
                            background: "white",
                            padding: "32px",
                          }}
                        >
                          <BenefitDetailBlockWrapper>
                            {benefit_detail?.entity_id && (
                              <DetailBlock title="Entity ID">
                                {benefit_detail.entity_id}
                              </DetailBlock>
                            )}
                            {benefit_detail?.dependents_covered && (
                              <DetailBlock title="Dependents Covered">
                                {benefit_detail.dependents_covered.join(", ")}
                              </DetailBlock>
                            )}
                            {benefit_detail?.redeem_option_data && (
                              <DetailBlock title="Coupon">
                                {benefit_detail.redeem_option_data}
                              </DetailBlock>
                            )}
                          </BenefitDetailBlockWrapper>
                          {benefit_detail?.benefit_heading && (
                            <DetailBlockMain title="Benefit Heading">
                              <Ptag color="#4A4A4A" fontSize="16px">
                                {benefit_detail?.benefit_heading}
                              </Ptag>
                            </DetailBlockMain>
                          )}
                          {benefit_detail?.benefit_description && (
                            <DetailBlockMain title="Benefit Description">
                              <Ptag color="#4A4A4A" fontSize="16px">
                                {benefit_detail?.benefit_description}
                              </Ptag>
                            </DetailBlockMain>
                          )}
                          {benefit_detail?.benefit_details?.filter(det => det && det.trim() !== "").length > 0 && (
                            <DetailBlockMain title="Benefit Details">
                              <ul
                                style={{
                                  listStylePosition: "inside",
                                }}
                              >
                                {benefit_detail?.benefit_details.filter(det => det && det.trim() !== "").map((det) => (
                                  <li
                                    key={det}
                                    style={{
                                      fontSize: "16px",
                                      fontFamily: "Inter",
                                      color: "#4a4a4a",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {det}
                                  </li>
                                ))}
                              </ul>
                            </DetailBlockMain>
                          )}
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}
        </div>
      )}
    </>
  );
}

export default BenefitSummary;
